import BannerBottomLeft from "Assets/Banners/bannerBottomLeft.jpeg";
import Cotations from "Assets/Images/HomeMenu/cotations.jpg";
import News from "Assets/Images/HomeMenu/news.jpg";
import Properties from "Assets/Images/HomeMenu/properties.jpg";
import AgroBoletins from "Assets/Images/HomeMenu/ti.jpg";
import Logo from "Assets/Images/logoTeste.png";
import Night from "Assets/Images/nightinfield.jpg";
import Rain from "Assets/Images/raininfield.jpg";
import Sun from "Assets/Images/suninfield.jpg";
import Carousel from "Components/Ad/Carousel";
import CampaignCarousel from "Components/Ad/CampaignCarousel";
import api from "Helpers/Api";
import { useArticles } from "Hooks/Articles/useArticles";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import localeActions from "Redux/Locale/actions";
import { ReducerState } from "Redux/store";
import Routes from "Routes";
import { TSection } from "Services/Article/section";
import { TBannerResponse } from "Services/Banners/banner";
import * as Styled from "./styles";

interface Props {
  section?: TSection;
  link?: string;
  search?: string;
  perPage?: number;
  hidePagination?: boolean;
}
interface CardData {
  title: string;
  imageUrl: string;
  painel: string;
}
interface WeatherData {
  time: Date;
  temperature: number;
  rain: number;
}
interface Location {
  latitude: number;
  longitude: number;
}
interface BannerImage extends TBannerResponse {
  width: number;
  height: number;
}

const mobile = window.innerWidth <= 720;
const smallMobile = window.innerWidth < 390;

const cardDataList: CardData[] = [
  {
    title: "Comercio Exterior",
    imageUrl:
      "https://storage.googleapis.com/rurax/powerbi/comercio%20-%20exportacao.png",
    painel:
      "https://app.powerbi.com/view?r=eyJrIjoiODVmZGQzZDYtYTgwZC00ZGFjLTg1NmMtMTEwNzliYjE4NTZlIiwidCI6IjNhYTk4NDFhLWJlNTgtNDdjMC04YjFhLTRmYWJmYjFiY2Y2NSJ9",
  },
  {
    title: "Produção Agricola Estadual",
    imageUrl:
      "https://storage.googleapis.com/rurax/powerbi/producao%20agricola%20estadual.png",
    painel:
      "https://app.powerbi.com/view?r=eyJrIjoiMjEwZGUwNjUtZDhhYi00ZjM0LWJkOGEtYzJkZjA2MjliYzk2IiwidCI6IjNhYTk4NDFhLWJlNTgtNDdjMC04YjFhLTRmYWJmYjFiY2Y2NSJ9",
  },
  {
    title: "Preços Agropecuários",
    imageUrl:
      "https://storage.googleapis.com/rurax/powerbi/pre%C3%A7os%20-%20soja.png",
    painel:
      "https://app.powerbi.com/view?r=eyJrIjoiODI4NjNlYmEtZmY1Mi00ZDY1LWI3YjQtNWYzNWFhMGQ3MjFjIiwidCI6IjNhYTk4NDFhLWJlNTgtNDdjMC04YjFhLTRmYWJmYjFiY2Y2NSJ9",
  },
];

const ArticlesHome: React.FC<Props> = ({
  section,
  search = "",
  perPage = search ? 9 : 6,
  hidePagination = true,
}) => {
  const history = useHistory();
  const { user } = useSelector((state: ReducerState) => state.auth);
  const dispatch = useDispatch();
  const [location, setLocation] = useState<Location | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [weather, setWeather] = useState<WeatherData | null>(null);

  const { data: articles } = useArticles({
    section,
    perPage: 100, //ver melhor solucao
  });
  // const { data: secondArticles } = useArticles({
  //   section: { category: "MERCADO,COTAÇÕES" },
  //   perPage: 4,
  //   page: 1,
  //   search: ""
  // });
  const [banners, setBanners] = useState<TBannerResponse[]>([]);
  const getBanner = async () => {
    try {
      const response = await api.get<TBannerResponse[]>("/banners/active");
      const dataFilter = response.data.filter(
        e => e.position === "banner_lateral"
      );
      setBanners(dataFilter);
    } catch (error) {
      setBanners([]);
    }
  };

  useEffect(() => {
    if ("geolocation" in navigator) {
      const watchId = navigator.geolocation.watchPosition(
        position => {
          const { latitude, longitude } = position.coords;
          console.log("Latitude is:", latitude);
          console.log("Longitude is:", longitude);
          setLocation({ latitude, longitude });
        },
        error => {
          setError(error.message);
        }
      );
      return () => navigator.geolocation.clearWatch(watchId);
    } else {
      setError("Geolocalização não é suportada por este navegador.");
    }
  }, []);

  useEffect(() => {
    if (location) {
      const fetchWeather = async () => {
        const params = {
          latitude: location.latitude,
          longitude: location.longitude,
          hourly: ["temperature_2m", "rain"],
          timezone: "America/Sao_Paulo",
          forecast_days: 1,
        };

        // Monta a query string da URL
        const queryString = new URLSearchParams({
          latitude: String(params.latitude),
          longitude: String(params.longitude),
          hourly: params.hourly.join(","), // a API espera os parâmetros separados por vírgula
          timezone: params.timezone,
          forecast_days: String(params.forecast_days),
        });

        const url = `https://api.open-meteo.com/v1/forecast?${queryString.toString()}`;

        try {
          const response = await fetch(url);
          const data = await response.json();

          const times: Date[] = data.hourly.time.map(
            (t: string) => new Date(t)
          );
          const temperatures: number[] = data.hourly.temperature_2m;
          const rains: number[] = data.hourly.rain;

          const now = new Date();
          const currentHour = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate(),
            now.getHours()
          );

          // Encontra o índice do array de horários que corresponde à hora atual
          const index = times.findIndex(time => {
            const t = new Date(
              time.getFullYear(),
              time.getMonth(),
              time.getDate(),
              time.getHours()
            );
            return t.getTime() === currentHour.getTime();
          });

          if (index !== -1) {
            setWeather({
              time: times[index],
              temperature: temperatures[index],
              rain: rains[index],
            });
            console.log(
              "Dados do clima:",
              times[index],
              temperatures[index],
              rains[index]
            );
          } else {
            setError("Dados para a hora atual não foram encontrados.");
          }
        } catch (err) {
          if (err instanceof Error) {
            setError("Erro ao buscar dados do clima: " + err.message);
          } else {
            setError("Erro ao buscar dados do clima");
          }
        }
      };

      fetchWeather();
    }
  }, [location]);

  useEffect(() => {
    getBanner();
  }, []);

  const cardFixos = [
    {
      tag_name: "Rurax na mídia",
      link: "/noticias/rurax",
      image: News,
    },
    {
      tag_name: "Clima",
      link: "",
      image: Properties,
    },
    {
      tag_name: "Agro Boletins",
      link: Routes.powerbi,
      image: AgroBoletins,
    },
    {
      tag_name: "Cotações",
      link: Routes.quotations,
      image: Cotations,
    },
  ];

  const getWeatherImage = (weather: {
    rain: number;
    time: { getHours: () => any };
  }) => {
    if (!weather) return Sun; // valor padrão

    if (weather.rain === 1) {
      return Rain;
    } else if (weather.rain === 0) {
      const hour = weather.time.getHours();
      if (hour >= 18 || hour < 5) {
        return Night;
      } else {
        return Sun;
      }
    }
    return Sun;
  };

  return (
    <>
      {(search || !search) && (
        <Styled.Section id="articles-home">
          <Styled.Highlight id="highlight">
            <Styled.Carousel>
              {articles && (
                <Carousel size={1} autoPlay>
                  {[...articles.data].map((item: any) => (
                    <Styled.CarouselCard
                      onClick={() => {
                        if (item.slug) {
                          history.push(`/noticia/${item.slug}`);
                        } else if (item.painel) {
                          history.push(`/agro-boletins?painel=${item.painel}`);
                        }
                      }}
                      key={item.slug || item.title}
                    >
                      <Styled.CarouselImage
                        style={{
                          backgroundSize: "cover",
                        }}
                        onError={(e: any) => {
                          e.target.src = Logo;
                        }}
                        src={
                          item.image_url?.startsWith("data:image")
                            ? Logo
                            : item.image_url || item.imageUrl || Logo
                        }
                      />
                      <Styled.CarouselContent
                        style={{
                          width: "78%",
                          marginBottom: window.innerWidth > 768 ? 80 : 20,
                        }}
                      >
                        <Styled.BtnCarouselCard
                          onClick={e => {
                            e.stopPropagation();
                            if (item.painel) {
                              history.push(
                                `/agro-boletins?painel=${item.painel}`
                              );
                            }
                          }}
                        >
                          Notícias
                        </Styled.BtnCarouselCard>
                        <Styled.CarouselTitle>
                          {item.title}
                        </Styled.CarouselTitle>
                      </Styled.CarouselContent>
                    </Styled.CarouselCard>
                  ))}
                </Carousel>
              )}
            </Styled.Carousel>
            <Styled.Cards>
              <Styled.FirstLineCards id="first-line-cards">
                {cardFixos?.slice(0, 2).map((article, index) => (
                  <Styled.Card
                    onClick={() => {
                      if (article.link) {
                        history.push(article.link);
                      }
                    }}
                    key={index}
                  >
                    {index !== 1 && (
                      <Styled.CardBtnType>
                        {article.tag_name}
                      </Styled.CardBtnType>
                    )}
                    {index === 1 && weather && (
                      <Styled.CardWeather>
                        <Styled.CardWeatherTitle>Clima</Styled.CardWeatherTitle>
                        <Styled.CardWeatherContent>
                          <Styled.CardWeatherTitleText>
                            Temp.
                          </Styled.CardWeatherTitleText>
                          <Styled.CardWeatherText>
                            {weather.temperature.toFixed(1)}°C
                          </Styled.CardWeatherText>
                        </Styled.CardWeatherContent>
                        <Styled.CardWeatherContent>
                          <Styled.CardWeatherTitleText>
                            Chuva
                          </Styled.CardWeatherTitleText>
                          <Styled.CardWeatherText>
                            {weather.rain.toFixed(1)}mm
                          </Styled.CardWeatherText>
                        </Styled.CardWeatherContent>
                      </Styled.CardWeather>
                    )}
                    {index === 1 && !weather && (
                      <Styled.CardWeather>
                        <Styled.CardWeatherBloqued>
                          Para obter informações sobre o clima, ative a sua
                          localização.
                        </Styled.CardWeatherBloqued>
                      </Styled.CardWeather>
                    )}

                    {index === 0 && (
                      <Styled.CardImage
                        onError={(e: any) => {
                          e.target.src = Logo;
                        }}
                        src={
                          article.image?.startsWith("data:image")
                            ? Logo
                            : article.image || Logo
                        }
                      />
                    )}
                    {index === 1 && (
                      <Styled.CardImage
                        onError={(e: any) => {
                          e.target.src = Logo;
                        }}
                        src={weather ? getWeatherImage(weather) : Sun}
                        alt="Condição do clima"
                      />
                    )}
                  </Styled.Card>
                ))}
              </Styled.FirstLineCards>

              <Styled.SecondLineCards>
                {cardFixos?.slice(2, 4).map((article, index) => (
                  <Styled.Card
                    onClick={() => {
                      if (article.link) {
                        history.push(article.link);
                      }
                    }}
                    key={index}
                  >
                    <Styled.CardBtnType>{article.tag_name}</Styled.CardBtnType>
                    <Styled.CardImage
                      onError={(e: any) => {
                        e.target.src = Logo;
                      }}
                      src={
                        article.image?.startsWith("data:image")
                          ? Logo
                          : article.image || Logo
                      }
                    />
                  </Styled.Card>
                ))}
              </Styled.SecondLineCards>
            </Styled.Cards>
          </Styled.Highlight>
          <Styled.SectionCardsBottom id="section-cards-bottom">
            <Styled.LeftSectionCardsBottom id="left-section-cards-bottom">
              <Styled.ImageLeftSectionCardsBottom
                id="image-left-section-cards-bottom"
                src={BannerBottomLeft}
              />
              <Styled.CardContent>
                <Styled.Tag>Lojas</Styled.Tag>
                <Styled.TextWrap>
                  <Styled.Title>Cadastre sua loja.</Styled.Title>
                  <Styled.Description>
                    {smallMobile
                      ? "Divulgue sua loja e aumente suas vendas."
                      : "Divulgue sua loja no nosso site e aumente suas vendas."}
                  </Styled.Description>
                </Styled.TextWrap>
                <Styled.Button onClick={() => history.push("/lojas-online")}>
                  Cadastre agora
                </Styled.Button>
              </Styled.CardContent>
            </Styled.LeftSectionCardsBottom>
            {!mobile && <SecondaryArticlesHome />}
          </Styled.SectionCardsBottom>

          {/* <Styled.LinkTitle href="/noticias/">
            ver mais notícias...
          </Styled.LinkTitle> */}
        </Styled.Section>
      )}
    </>
  );
};

const SecondaryArticlesHome: React.FC<Props> = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { user } = useSelector((state: ReducerState) => state.auth);
  const [banners, setBanners] = useState<BannerImage[]>([]);

  const getImageDimensions = (
    url: string
  ): Promise<{ width: number; height: number }> => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = url;
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.onerror = reject;
    });
  };

  const getBanner = async () => {
    try {
      const response = await api.get<TBannerResponse[]>("/banners/active");
      const dataFilter = response.data.filter(
        e => e.position === "banner_lateral"
      );

      const bannersWithDimensions = await Promise.all(
        dataFilter.map(async banner => {
          try {
            const { width, height } = await getImageDimensions(banner.image);
            return { ...banner, width, height };
          } catch {
            return { ...banner, width: 0, height: 0 }; // fallback se a imagem falhar
          }
        })
      );

      setBanners(bannersWithDimensions);
    } catch (error) {
      setBanners([]);
    }
  };
  useEffect(() => {
    getBanner();
  }, []);

  return (
    <>
      {" "}
      {banners && banners.length > 0 ? (
        <Styled.RightSectionCardsBottom id="Right-section-cards-bottom">
          <CampaignCarousel size={1} autoPlay>
            {banners.map(item => (
              <Styled.CarouselCardBottom
                onClick={e => {
                  if (item.link) {
                    e.stopPropagation();
                    let url = item.link.trim();
                    if (!/^https?:\/\//i.test(url)) {
                      url = `https://${url}`;
                    }
                    window.open(url, "_blank");
                  }
                }}
                key={item.id}
              >
                {!item.enabled && (
                  <Styled.BtnCarouselCardBottom
                  // onClick={e => {
                  //   e.stopPropagation();
                  //   if (item.painel) {
                  //     history.push(
                  //       `/agro-boletins?painel=${item.painel}`
                  //     );
                  //   }
                  // }}
                  >
                    ANÚNCIOS
                  </Styled.BtnCarouselCardBottom>
                )}
                <Styled.CarouselImage
                  src={item.image}
                  aspectRatio={item.width / item.height}
                />
                {/* <Styled.CarouselTitleBottom>
                        {item.title}
                      </Styled.CarouselTitleBottom>
                      <Styled.CarouselSub
                        style={{
                          bottom:
                            item.description.length > 37 ? "113px" : "138px"
                        }}
                      >
                        {item.description}
                      </Styled.CarouselSub> */}
                {!item.enabled && (
                  <Styled.CarouselSubTitleBottom
                    onClick={e => {
                      e.stopPropagation();
                      user
                        ? dispatch(localeActions.modal())
                        : history.push(Routes.login);
                    }}
                  >
                    Anuncie agora
                  </Styled.CarouselSubTitleBottom>
                )}
              </Styled.CarouselCardBottom>
            ))}
          </CampaignCarousel>
        </Styled.RightSectionCardsBottom>
      ) : (
        <Styled.LeftSectionCardsBottom id="left-section-cards-bottom">
          <Styled.ImageLeftSectionCardsBottom src={Logo} />
          <Styled.CardContent>
            <Styled.Tag>NOTÍCIAS</Styled.Tag>
            <Styled.Title>Principais notícias.</Styled.Title>
            <Styled.Description>
              Matérias sobre pecuária, agricultura, mercado e muito mais.
            </Styled.Description>
            <Styled.Button
              onClick={e => {
                e.stopPropagation();
                history.push(Routes.articles.replace(":category?", ""));
              }}
            >
              Ver mais notícias
            </Styled.Button>
          </Styled.CardContent>
        </Styled.LeftSectionCardsBottom>
      )}
    </>
  );
};

export { SecondaryArticlesHome };
export default ArticlesHome;
